import { render, staticRenderFns } from "./CreateMain.vue?vue&type=template&id=71d45d18&lang=pug&"
import script from "./CreateMain.vue?vue&type=script&lang=js&"
export * from "./CreateMain.vue?vue&type=script&lang=js&"
import style0 from "./CreateMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateMain.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
